import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Textarea,
    VStack,
    HStack,
    Text,
    useToast,
    useDisclosure
} from "@chakra-ui/react";

import { use, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const SessionRestorePopup = () => {
    const navigate = useNavigate()
    const userData = JSON.parse(localStorage.getItem("user"));
    const [isOpen, setIsOpen] = useState(userData?.authToken ? true : false,)

    const handleAction = (type) => {
        if (type == "Yes") {
            if (userData && userData?.authToken) {
                setIsOpen(false)
                navigate(userData.role === 1 ? "/driver/map" : "/user/map");
            }
        }
        else {
            setIsOpen(false)
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
            <ModalOverlay />

            <ModalContent>
                <ModalHeader>Login Alert</ModalHeader>

                <ModalBody>
                    Do you want to restore your previous login?
                </ModalBody>

                <ModalFooter>
                    <Button mr={3} onClick={() => handleAction("Yes")} >
                        Yes
                    </Button>
                    <Button
                        colorScheme="teal"
                        onClick={() => handleAction("No")}
                        type="button"
                    >
                        No
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default SessionRestorePopup;